/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDataSetCategoriesListStyles = makeStyles(theme => ({
  root: {},
  list: {},
  title: {
    color: theme.palette.text.primary,
    fontSize: '10px',
    lineHeight: '13px',
    margin: '0 12px 12px',
  },
  item: {
    display: 'flex',
    width: '100%',
    minHeight: '48px',
    padding: '14px 8px 14px 22px',
    backgroundColor: '#F6F7F8',
    borderRadius: '6px',
    justifyContent: 'left',
    marginTop: '14px',
    color: '#000000',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '20px',
    position: 'relative',
    textAlign: 'left',

    '&:first-child': {
      marginTop: 0,
    },

    '&$itemActive': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      backgroundColor: `${theme.palette.tertiary.main}20`,
      '& $itemCount': {
        color: 'inherit',
      },
      '& $itemArrow': {
        opacity: 1,
      },
    },
  },
  itemTitle: {
    flex: '1',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  itemActive: {},
  itemWithThumbnail: {
    paddingLeft: '54px',
  },
  itemThumbnail: {
    position: 'absolute',
    width: '24px',
    height: '24px',
    left: '8px',
    top: '50%',
    transform: 'translateY(-50%)',

    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  itemCount: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 'bold',
    flex: '0 0 auto',
    letterSpacing: '0',
  },
  itemArrow: {
    width: '24px',
    height: '24px',
    opacity: 0,

    '& svg': {
      transform: 'rotate(-90deg) ',
      width: '100%',
      height: '100%',
    },
  },
  itemBadges: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    marginLeft: '5px',
    // position: "absolute",
    // top: "50%",
    // transform: "translateY(-50%)",
    // right: "8px",
  },
  noOptionsText: {
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
  },
}));
